// File: src/pages/seller/AddProduct/sections/ProductDescription.jsx
import React from "react";
import { useFormContext, Controller } from "react-hook-form";
import {
  CRow,
  CCol,
  CFormLabel,
  CFormInput,
  CButton,
  CSpinner,
} from "@coreui/react";
import TipTapEditor from "../../../../components/seller/TipTapEditor.jsx";
import CIcon from "@coreui/icons-react";
import { cilLightbulb } from "@coreui/icons";

const ProductDescription = ({ kycType, onGenerateAi, aiLoading }) => {
  const {
    control,
    register,
    formState: { errors },
    setValue,
  } = useFormContext();

  return (
    <div
      style={{
        border: "1px solid #dcdcdc",
        borderRadius: "8px",
        padding: "1.5rem",
        position: "relative",
        marginBottom: "1.5rem",
      }}
    >
      {/* Section Title */}
      <span
        style={{
          position: "absolute",
          top: "-0.8rem",
          left: "1rem",
          backgroundColor: "white",
          padding: "0 0.5rem",
          fontWeight: "600",
          color: "#333",
          fontSize: "1rem",
        }}
      >
        Product Information
      </span>

      {/*  Product Name */}
      <CRow className="mb-3">
        <CCol md={12}>
          <CFormLabel>Product Name</CFormLabel>
          <CFormInput {...register("name")} />
          {errors.name && (
            <div style={{ color: "red" }}>{errors.name.message}</div>
          )}
        </CCol>
      </CRow>

      {/*  Product Description */}
      <CRow className="mb-3">
        <CCol md={12}>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <CFormLabel className="mb-0">Description</CFormLabel>
            <CButton
              type="button"
              color="secondary"
              size="sm"
              variant="outline"
              disabled={aiLoading}
              onClick={onGenerateAi}
            >
              {aiLoading ? (
                <CSpinner size="sm" />
              ) : (
                <>
                  <CIcon icon={cilLightbulb} className="me-1" />
                  Generate with AI
                </>
              )}
            </CButton>
          </div>
          <Controller
            name="description"
            control={control}
            render={({ field }) => (
              <TipTapEditor
                content={field.value}
                onChange={field.onChange}
              />
            )}
          />
          {errors.description && (
            <div style={{ color: "red" }}>{errors.description.message}</div>
          )}
        </CCol>
      </CRow>
    </div>
  );
};

export default React.memo(ProductDescription);
